
export default {
	props: {
		page: {
			type: Object,
			default: {},
		},
	},
};
